import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import {
  useOutstandingLegalAcceptances,
  useAcceptLegal,
} from '@/hooks/legal/useLegalAcceptance';

const ROUTE_BY_TYPE: Record<string, string> = {
  imprint: '/impressum',
  privacy: '/datenschutz',
  terms: '/nutzungsbedingungen',
};

/**
 * LegalReacceptanceModal — shown when the authenticated user has outstanding
 * legal acceptances (e.g. a new Terms version was published). Blocks app
 * interaction until the user accepts.
 */
export default function LegalReacceptanceModal() {
  const { data: outstanding } = useOutstandingLegalAcceptances();
  const accept = useAcceptLegal();

  if (!outstanding || outstanding.length === 0) return null;
  const next = outstanding[0];

  return (
    <Dialog open onOpenChange={() => { /* not dismissable */ }}>
      <DialogContent
        className="sm:max-w-md"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Aktualisierte {next.title}</DialogTitle>
          <DialogDescription>
            Wir haben {next.title} aktualisiert. Um Scuvio weiter zu nutzen,
            bestätige bitte die neue Fassung (Version {next.version}).
          </DialogDescription>
        </DialogHeader>

        <div className="text-sm">
          <Link
            to={ROUTE_BY_TYPE[next.document_type] ?? '/'}
            target="_blank"
            rel="noreferrer"
            className="text-primary underline"
          >
            {next.title} ansehen
          </Link>
        </div>

        <div className="flex justify-end pt-2">
          <Button
            onClick={() =>
              accept.mutate({ document_type: next.document_type, version: next.version })
            }
            disabled={accept.isPending}
            className="gap-2"
          >
            {accept.isPending && <Loader2 className="w-4 h-4 animate-spin" />}
            Akzeptieren
          </Button>
        </div>

        {outstanding.length > 1 && (
          <p className="text-xs text-muted-foreground">
            Noch {outstanding.length - 1} weitere Dokument(e) ausstehend.
          </p>
        )}
      </DialogContent>
    </Dialog>
  );
}